import 'bootstrap/js/collapse';
import '../src/base';
import '~/app/assets/javascripts/application/sitewide';
import '~/app/assets/javascripts/application/help_center/init_canonical_selector';
import accordion from '~/app/assets/javascripts/application/shared/accordion';
import '~/app/assets/javascripts/application/shared/create_wish_using_explanation_and_lead_form';

accordion();
